export default __webpack_public_path__ + "static/media/close_icon_small.02c45b0e.svg";